<div class="shared-multiselect-wrapper">
  <ng-multiselect-dropdown
    class="shared-multiselect"
    [placeholder]="placeholder"
    [data]="data"
    [settings]="mergedSettings"
    [disabled]="disabled"
    [(ngModel)]="value"
    (ngModelChange)="onModelValueChange($event)"
    (onDropDownClose)="onDropdownClose()"
    (onFilterChange)="onFilterValueChange($event)"
    (onSelect)="onSelectItem($event)"
    (onDeSelect)="onDeSelectItem($event)"
    (onSelectAll)="onSelectAllItems($event)"
    (onDeSelectAll)="onDeSelectAllItems($event)"
  >
  </ng-multiselect-dropdown>

  <i
    *ngIf="showArrow"
    class="fa-solid fa-angle-down dropdown-icon"
  ></i>
</div>
